import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react';
import { contactInfo } from '../mockData';
import MindLifeLogo from './MindLifeLogo';

const Footer = () => {
  // Scroll to top when clicking links
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer" data-testid="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section">
            <div className="footer-logo">
              <MindLifeLogo height="45px" showText={true} />
            </div>
            <p className="footer-description">
              Centro psicológico especializado en el bienestar emocional y mental. 
              Comprometidos con tu salud mental y crecimiento personal.
            </p>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Enlaces Rápidos</h3>
            <ul className="footer-links">
              <li><Link to="/" onClick={scrollToTop}>Inicio</Link></li>
              <li><Link to="/servicios" onClick={scrollToTop}>Servicios</Link></li>
              <li><Link to="/nosotros" onClick={scrollToTop}>Nosotros</Link></li>
              <li><Link to="/videos" onClick={scrollToTop}>Videos</Link></li>
              <li><Link to="/contacto" onClick={scrollToTop}>Contacto</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3 className="footer-title">Servicios</h3>
            <ul className="footer-links">
              <li><Link to="/servicios" onClick={scrollToTop}>Terapia Individual</Link></li>
              <li><Link to="/servicios" onClick={scrollToTop}>Terapia de Pareja</Link></li>
              <li><Link to="/servicios" onClick={scrollToTop}>Psicología Infantil</Link></li>
              <li><Link to="/servicios" onClick={scrollToTop}>Neuropsicología</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-title">Contacto</h3>
            <ul className="footer-contact">
              <li>
                <Phone size={16} />
                <a href={`https://wa.me/51${contactInfo.whatsapp}`}>
                  {contactInfo.whatsappDisplay}
                </a>
              </li>
              <li>
                <Mail size={16} />
                <a href={`mailto:${contactInfo.email}`}>
                  {contactInfo.email}
                </a>
              </li>
              <li>
                <MapPin size={16} />
                <span>{contactInfo.address}</span>
              </li>
            </ul>
            <p className="footer-schedule">{contactInfo.schedule}</p>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Mind Life Centro Psicológico. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
